/* Selectbox - react-select v5 style configuration */
import type { CSSObjectWithLabel, GroupBase, StylesConfig } from 'react-select';
import Select from 'react-select';

export { Select };
export const selectboxWrapperClassName = 'Selectbox-react-select';

/**
 * Shared react-select v5 styles that override Emotion's inline defaults.
 * These ensure the select looks identical to the old v1 styling.
 */
export const reactSelectStyles: StylesConfig<{ value: string; label: string }, false, GroupBase<{ value: string; label: string }>> = {
  control: (base: CSSObjectWithLabel, state) => ({
    ...base,
    border: '1px solid #d0d0d0',
    boxShadow: 'none',
    minHeight: '28px',
    height: '28px',
    borderColor: state.isFocused ? '#a0a0a0' : '#d0d0d0',
    '&:hover': {
      borderColor: state.isFocused ? '#a0a0a0' : '#d0d0d0',
      boxShadow: 'none',
    },
    borderRadius: '4px',
    cursor: 'pointer',
  }),
  valueContainer: (base: CSSObjectWithLabel) => ({
    ...base,
    padding: '0 8px',
    height: '26px',
  }),
  singleValue: (base: CSSObjectWithLabel) => ({
    ...base,
    lineHeight: '26px',
    color: '#333',
  }),
  placeholder: (base: CSSObjectWithLabel) => ({
    ...base,
    lineHeight: '26px',
    color: '#aaa',
  }),
  input: (base: CSSObjectWithLabel) => ({
    ...base,
    margin: 0,
    padding: 0,
    height: '26px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (base: CSSObjectWithLabel) => ({
    ...base,
    padding: '0 6px',
    color: '#999',
    '&:hover': {
      color: '#666',
    },
  }),
  menu: (base: CSSObjectWithLabel) => ({
    ...base,
    zIndex: 9999,
    borderRadius: '4px',
    marginTop: '2px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
  }),
  menuPortal: (base: CSSObjectWithLabel) => ({
    ...base,
    zIndex: 9999,
  }),
  menuList: (base: CSSObjectWithLabel) => ({
    ...base,
    padding: '2px 0',
  }),
  option: (base: CSSObjectWithLabel, state) => ({
    ...base,
    padding: '4px 8px',
    fontSize: '14px',
    cursor: 'pointer',
    backgroundColor: state.isSelected ? 'transparent' : state.isFocused ? '#e1eefb' : 'transparent',
    color: '#333',
    '&:active': {
      backgroundColor: '#e1eefb',
    },
  }),
};
